<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-11-04 17:35:37
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
    <!-- 漂浮框 -->
    <div
      @click="pfkbox = true"
      v-if="pcshow"
      @mouseover="mouseover"
      @mouseout="mouseout"
      class="pcbox"
      :style="{
        top: top + 'px',
        left: left + 'px',
        backgroundImage: 'url(' + tcData.imgUrl + ')'
      }"
      ref="boxRef"
    >
      <img
        src="@/assets/images/closeplain.png"
        style="width: 24px;height: 24px;"
        @click.stop="close"
        class="closeBtn"
      />
      <div class="info-text"></div>
    </div>
    <!-- 弹窗 -->
    <div
      v-if="pfkbox"
      style="position: fixed;left: 0;width: 100%;top: 0;bottom: 0;background: rgba(0, 0, 0, 0.5);z-index: 9991;"
    >
      <div class="pfc-box">
        <div class="pfc-box-tt">
          <div class="left">{{ tcData.name }}</div>
          <div class="right" @click="pfkbox = false">×</div>
        </div>
        <div style="padding: 20px;" v-html="tcData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dome",
  data() {
    return {
      pfkbox: false,
      tcData: {},
      pcshow: false, // 是否展现飘窗
      directionX: "right", //飘窗的x轴方向 right left
      directionY: "down", //飘窗的Y轴方向 down  up
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: "", // 定时器
      clientHeight: 0, // 最大的 top 值
      clientWidth: 0, // 最大的 left 值
      height: 0, //元素的高
      width: 0, //元素的宽
      top: 0, //头部距离
      left: 0 //左侧距离
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.gettc();
    });
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    gettc() {
      this.$get("/website/getWebsiteHangWindow").then(res => {
        res.data.imgUrl = process.env.VUE_APP_minioURL + res.data.imgUrl;
        this.tcData = res.data;
        if (res.data.status == 1) {
          this.pcshow = true;
        }
        setTimeout(() => {
          this.init();
          this.onresize();
        }, 1000);
      });
    },
    // 初始化飘窗规则
    init() {
      // 获取元素的高度
      this.height = this.$refs.boxRef.offsetHeight;
      // 获取元素的宽度
      this.width = this.$refs.boxRef.offsetWidth;
      // 获取可视屏幕的高度
      this.clientHeight = document.documentElement.clientHeight;
      // 获取可视屏幕的宽度
      this.clientWidth = document.documentElement.clientWidth;
      // 开始移动函数
      this.start();
    },
    // 开始设置定时器进行移动
    start() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = setInterval(() => {
        this.move();
      }, 15);
    },
    // 移动函数
    move() {
      // 因为刚开始默元素位置是 0,0 在屏幕的左上角

      //判断移动方向
      //1 向右移动时
      if (this.directionX == "right") {
        // 判断 移动的距离加上元素的宽度加上步长 是否大于 可视屏幕的宽度
        // 如果大于屏幕宽度就表示碰到了 右侧的边界 并进行修改方向
        if (this.left + this.width + this.stepX > this.clientWidth) {
          this.directionX = "left";
        }
        //2 向左移动时
      } else {
        // 只需要判断 用之前移动的左侧距离减去步长 当小于0时就表示碰到了左侧的边界
        if (this.left - this.stepX < 0) {
          this.directionX = "right";
        }
      }
      // 3 向下移动
      if (this.directionY == "down") {
        // 同理 需要判断当前 距离头部的距离加上元素的高度加上步长 是否大于可视屏幕的高度
        // 如果大于可视屏幕高度就表示碰到了 屏幕底部的边界
        if (this.top + this.height + this.stepY > this.clientHeight) {
          this.directionY = "up";
        }
        // 4 向上移动
      } else {
        // 只需要判断 用之前移动的头部距离减去步长 当小于0时就表示碰到了屏幕上边的边界
        if (this.top - this.stepY < 0) {
          this.directionY = "down";
        }
      }

      //移动操作
      // 向右移动时将左侧的距离根据定时器的触发进行加上每次的步长
      if (this.directionX == "right") {
        this.left += this.stepX;
        // 向左移动时就需要将之前获取到的左侧距离减去步长
      } else {
        this.left -= this.stepX;
      }
      // 向下移动时将距离头部的距离根据定时器的触发加上每次的步长
      if (this.directionY == "down") {
        this.top += this.stepY;
        // 向上移动时需要将之前获取到的头部距离减去步长
      } else {
        this.top -= this.stepY;
      }
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer);
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      this.start();
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer);
      this.pcshow = false;
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this;
      window.onresize = function() {
        that.init();
      };
    }
  }
};
</script>

<style scoped>
.pcbox {
  z-index: 2000;
  cursor: pointer;
  background-color: #84a7e7;
  background-size: contain;
  width: 272px;
  height: 140px;
  background: url("~@/assets/images/gwpiaochuang.jpg") center center no-repeat;
  background-size: 100%;
  position: fixed;
  text-align: left;
  color: #ffffff;
  top: 0;
  left: 0;
}
.pcbox .closeBtn {
  position: absolute;
  right: 4px;
  top: 4px;
}
.pfc-box {
  width: 700px;
  margin-left: -350px;
  min-height: 300px;
  max-height: 600px;
  overflow-y: auto;
  background: #fff;
  border-radius: 4px;
  position: fixed;
  z-index: 9992;
  left: 50%;
  top: 20%;
}
.pfc-box .pfc-box-tt {
  overflow: hidden;
  height: 60px;
  line-height: 60px;
  background: url("~@/assets/images/tcttbg.png") no-repeat left center;
  background-size: auto 100%;
}
.pfc-box .pfc-box-tt .left {
  float: left;
  color: #fff;
  font-size: 20px;
  padding-left: 15px;
  font-weight: bold;
}
.pfc-box .pfc-box-tt .right {
  float: right;
  font-size: 36px;
  color: #fff;
  padding-right: 15px;
  cursor: pointer;
}
</style>
